import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'utils/types';
import orderSelectors from 'state/order/selectors';

import SuggestedTimes from 'components/form/SuggestedTimes/component';

const filterOptions = (optionsToShow, value, shouldFilter, hasHelpText) => {
  const options = optionsToShow;
  if (hasHelpText) {
    options[0] = {
      ...(options[0] || {}),
      subText: 'earliest_possible_arrival',
    };
  }
  if (!shouldFilter) return options;
  const optionsFiltered = options.filter((option) =>
    !isEmpty(value) && value !== 0 && option.raw
      ? option.raw.indexOf(String(value)) !== -1
      : true
  );
  if (
    optionsFiltered.length >= 1 &&
    isEmpty(optionsFiltered[optionsFiltered.length - 1].raw)
  )
    optionsFiltered.pop();
  return optionsFiltered;
};

const enhance = compose(
  withTranslation('SuggestedTimes'),
  connect(
    (
      state,
      { shipmentKey, stopType, timeField, value, shouldFilter, hasHelpText }
    ) => ({
      scrollToHourOnOpen: stopType === 'pickup' && timeField === 'time_from',
      options: filterOptions(
        orderSelectors.getSuggestedTimesObjects(
          state,
          shipmentKey,
          stopType,
          timeField
        ),
        value,
        shouldFilter,
        hasHelpText
      ),
    })
  ),
  withHandlers(() => ({
    handleChange:
      ({ onChange }) =>
      ({ value, diffDay }) => {
        onChange(undefined, { value, diffDay, closeModal: true });
      },
  }))
);

export default enhance(SuggestedTimes);
